<template>
    <kgr-form-scaffold
        :pending="pending || pendingRemove"
        :with-delete-button="true"
        :save-button-disabled="saveButtonDisabled"
        edit-mode
        @primary-btn-clicked="updateOffering"
        @back-btn-clicked="redirectToOverview"
        @delete-btn-clicked="deleteOffering"
    >
        <template #additional-buttons>
            <button
                class="kgr-button kgr-button--accent"
                @click="redirectToAppointmentView"
            >
                {{ $t('offering.toAppointmentView') }}
            </button>
        </template>
        <kgr-offering-edit-form
            v-if="offering !== null"
            :club-id="clubId"
            :offering-prop="offering"
            :error="error"
            :save-action="pending"
            :sales-list-module-enabled="salesListModuleEnabled"
            @enter="updateOffering"
            @appointment-invalid="saveButtonDisabled = $event"
            @offering-items-selected="addOfferingItems($event)"
        />
        <template #additional-footer-button>
            <kgr-archive-offering-button
                v-if="null !== offering"
                :offering="offering"
                @archive-offering="offering.archived = true"
                @restore-offering="offering.archived = false"
            />
        </template>
    </kgr-form-scaffold>
</template>

<script>
import ArchiveOfferingButton from '../../components/offering/ArchiveOfferingButton.vue';
import Error from '../../js/model/Error';
import EventBus from '../../js/service/EventBus.js';
import ExamOfferingRepository from '../../js/repository/club/offering/ExamOfferingRepository';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrOfferingEditForm from '../../components/offering/OfferingExamEditForm';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository';
import OfferingValidator from '../../js/offering/OfferingValidator';

export default {
    components: {
        'kgr-archive-offering-button': ArchiveOfferingButton,
        'kgr-form-scaffold': FormScaffold,
        'kgr-offering-edit-form': KgrOfferingEditForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: false,
        },
        salesListModuleEnabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            offering: null,
            error: new Error(),
            saveButtonDisabled: false,
        };
    },
    computed: {
    },
    created() {
        if (this.offeringId.length !== 0) {
            this.loadOffering();
        }
    },
    methods: {
        loadOffering() {
            ExamOfferingRepository.find(this.offeringId)
                .then((offering) => this.offering = offering)
                .catch(() => this.$notify.error('error.loadingData'));
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        updateOffering() {
            this.error = OfferingValidator.validateExamOffering(this.offering);
            if (!this.error.isEmpty()) {
                return this.$notify.error('saveChanges.error');
            }

            this.pending = true;
            ExamOfferingRepository.update(this.offering)
                .then(() => {
                    this.loadArchivable();
                    this.$notify.success('saveChanges.success');
                    EventBus.$emit('offering-updated');
                })
                .catch((error) => {
                    this.error = error;
                    // The reason rides in the violation details; without appending them the user only ever
                    // learns that saving failed, which is what turned a missing right into a support ticket.
                    this.$notify.error(['saveChanges.error', ...error.allMessages()]);
                })
                .finally(() => this.pending = false);
        },
        loadArchivable() {
            if (!this.offering.archived) {
                OfferingRepository.isArchivable(this.offeringId)
                    .then((response) => this.offering.isArchivable = response);
            }
        },
        redirectToAppointmentView() {
            window.location = `/backend/clubs/${this.clubId}/exam-offerings/${this.offering.id}/view`;
        },
        deleteOffering() {
            if (this.offering.isDeletable) {
                showConfirm(this.$t('confirm'), this.$t('Soll das Prüfungsangebot wirklich gelöscht werden?', {}), () => {
                    this.pendingRemove = true;
                    OfferingRepository.delete(this.offering.id)
                        .then(() => {
                            this.$notify.success('Das Prüfungsangebot Kurs wurde gelöscht');
                            this.redirectToOverview();
                        })
                        .catch(() => this.$notify.error('Das Prüfungsangebot Kurs konnte nicht gelöscht werden'))
                        .finally(() => this.pendingRemove = false);
                }, 'Ok');
            } else {
                showAlert(this.$t('offering.exam.notDeletable'), this.$t('offering.exam.notDeletable.information', {}));
            }
        },
        addOfferingItems(offeringItems) {
            this.offering.salesListOfferingItems = offeringItems;
        },
    },
    render() {
        return this.$slots.redirectToAppointmentView();
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
